import { isEmbedPath } from './context/EmbedContext';
import MainApp from './MainApp';
import EmbedApp from './EmbedApp';

export default function App() {
  return isEmbedPath() ? <EmbedApp /> : <MainApp />;
}
